
import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

export interface XmlImportOptions {
    file: File;
    tournamentId: string;
}

@Component({
    selector: 'app-xml-import-modal',
    standalone: true,
    templateUrl: './xml-import-modal.component.html',
    styleUrls: ['./xml-import-modal.component.scss'],
    imports: [FormsModule],
})
export class XmlImportModalComponent {
    @Output() importConfirmed = new EventEmitter<XmlImportOptions>();

    isVisible = false;
    selectedFile: File | null = null;
    tournamentId: string = '';
    fileName: string = '';

    openModal(tournamentId: string): void {
        this.tournamentId = tournamentId;
        this.selectedFile = null;
        this.fileName = '';
        this.isVisible = true;
    }

    closeModal(): void {
        this.isVisible = false;
        this.selectedFile = null;
        this.fileName = '';
    }

    onFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
            this.selectedFile = input.files[0];
            this.fileName = this.selectedFile.name;
        }
    }

    confirmImport(): void {
        if (this.selectedFile) {
            this.importConfirmed.emit({
                file: this.selectedFile,
                tournamentId: this.tournamentId
            });
            this.closeModal();
        }
    }

    get isValidFile(): boolean {
        return this.selectedFile !== null && this.fileName.toLowerCase().endsWith('.xml');
    }
}
